var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.$t('common.version_trial'))+" "),_c('div',{staticClass:"actions"},[_c('v-btn',{attrs:{"color":"primary","dark":"","text":""},on:{"click":function($event){return _vm.$emit('closeModal')}}},[_vm._v(" "+_vm._s(_vm.$t('common.ok'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }